import { render, staticRenderFns } from "./IncidentReportSectionToggles.vue?vue&type=template&id=62134550"
import script from "./IncidentReportSectionToggles.vue?vue&type=script&lang=js"
export * from "./IncidentReportSectionToggles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports